<template>
  <VModal
      class="text-gray-500"
      :show="$infoModal.value"
      @click="$infoModal.value = false">

    <p class="mt-4 text-sm ">{{ $infoModal.value }}</p>

    <VButton class="mt-4 w-full"
             @click="$infoModal.value = false">باشه</VButton>
  </VModal>
</template>

<script>
import VButton from "@/components/General/VButton";
import VModal from "@/components/General/VModal.vue";

export default {
  name: "InfoModal",
  components: {VModal, VButton},
}
</script>

<style scoped>

</style>